import React, { useEffect, useState } from "react";

import {
    Box,
    Card,
    CardContent,
    Typography,
    Chip,
    TablePagination,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    TextField,
    CircularProgress,
    Divider,
    Select,
    MenuItem
} from "@mui/material";
import { BsDownload } from "react-icons/bs";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";

const SEARCH_BY_OPTIONS = [
    { value: "poojaName", label: "Pooja Name" },
    { value: "astrologerName", label: "Astrologer Name" }
];

function PoojaMapping() {
    const [loading, setLoading] = useState(false);
    const [viewOpen, setViewOpen] = useState(false);
    const [selectedMapping, setSelectedMapping] = useState(null);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchText, setSearchText] = useState("");
    const [searchBy, setSearchBy] = useState(SEARCH_BY_OPTIONS[0].value);
    const [appliedSearch, setAppliedSearch] = useState("");
    const [appliedSearchBy, setAppliedSearchBy] = useState(SEARCH_BY_OPTIONS[0].value);
    const [exportLoading, setExportLoading] = useState(false);
    const [pagination, setPagination] = useState({
        totalDocs: 0,
        totalPages: 1,
        page: 1,
        limit: 10,
    });

    const [mappings, setMappings] = useState([]);
    const [editOpen, setEditOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [editData, setEditData] = useState({
        finalUserPrice: "",
        finalOfferUserPrice: "",
        companyShare: "",
        astrologerShare: "",
        poojaDescription: "",
    });
    const [actionLoading, setActionLoading] = useState(false);

    const fetchMappings = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("astroVani-admin-token");
            const searchParamStr = appliedSearch ? `&${appliedSearchBy}=${encodeURIComponent(appliedSearch)}` : "";

            const response = await fetch(
                `${process.env.REACT_APP_BASEURL}/admin/pooja/mapping?page=${paginationModel.page + 1
                }&limit=${paginationModel.pageSize}${searchParamStr}`,
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            const result = await response.json();

            if (response.ok) {
                setMappings(result?.data || []);
                setPagination(result?.paginationDetail || {});
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMappings();
    }, [
        paginationModel.page,
        paginationModel.pageSize,
        appliedSearch,
        appliedSearchBy
    ]);

    const handleApplySearch = () => {
        setAppliedSearch(searchText.trim());
        setAppliedSearchBy(searchBy);
        setPaginationModel((prev) => ({
            ...prev,
            page: 0,
        }));
    };

    const handleResetSearch = () => {
        setSearchText("");
        setAppliedSearch("");
        setSearchBy(SEARCH_BY_OPTIONS[0].value);
        setAppliedSearchBy(SEARCH_BY_OPTIONS[0].value);
        setPaginationModel({
            page: 0,
            pageSize: 10,
        });
    };

    const handleEdit = (row) => {
        setSelectedId(row._id);
        setSelectedMapping(row);

        setEditData({
            finalUserPrice: row.finalUserPrice || "",
            finalOfferUserPrice: row.finalOfferUserPrice || "",
            companyShare: row.companyShare || "",
            astrologerShare: row.astrologerShare || "",
            poojaDescription: row.poojaDescription || "",
        });

        setEditOpen(true);
    };
    const handleDeleteOpen = (row) => {
        setSelectedId(row._id);
        setDeleteOpen(true);
    };
    const handleUpdate = async () => {
        try {
            setActionLoading(true);

            const token = localStorage.getItem(
                "astroVani-admin-token"
            );


            const finalPrice = Number(editData.finalUserPrice);
            const offerPrice = Number(editData.finalOfferUserPrice);
            const companyShare = Number(editData.companyShare);
            const astrologerShare = Number(editData.astrologerShare);

            if (finalPrice < 0 || offerPrice < 0) {
                toast.error("Prices cannot be negative");
                return;
            }

            if (companyShare < 0 || astrologerShare < 0) {
                toast.error("Share percentages cannot be negative");
                return;
            }

            if (finalPrice < offerPrice) {
                toast.error(
                    "Price must be greater than or equal to Offer Price"
                );
                return;
            }

            if (companyShare + astrologerShare !== 100) {
                toast.error(
                    "Company Share % + Astrologer Share % must equal 100"
                );
                return;
            }

            const response = await fetch(
                `${process.env.REACT_APP_BASEURL}/admin/pooja/mapping/${selectedId}`,
                {
                    method: "PATCH",
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        finalUserPrice: Number(
                            editData.finalUserPrice
                        ),
                        finalOfferUserPrice: Number(
                            editData.finalOfferUserPrice
                        ),
                        companyShare: Number(
                            editData.companyShare
                        ),
                        astrologerShare: Number(
                            editData.astrologerShare
                        ),
                        poojaDescription:
                            editData.poojaDescription,
                    }),
                }
            );

            const result = await response.json();

            if (!response.ok || result?.success === false) {
                throw new Error(
                    result?.message || "Update failed"
                );
            }

            toast.success(
                "Mapping updated successfully"
            );

            setEditOpen(false);

            fetchMappings();
        } catch (error) {
            toast.error(error.message);
        } finally {
            setActionLoading(false);
        }
    };
    const handleDelete = async () => {
        try {
            setActionLoading(true);

            const token = localStorage.getItem(
                "astroVani-admin-token"
            );

            const response = await fetch(
                `${process.env.REACT_APP_BASEURL}/admin/pooja/mapping/${selectedId}`,
                {
                    method: "DELETE",
                    headers: {
                        Authorization: token,
                    },
                }
            );

            const result = await response.json();

            if (!response.ok || result?.success === false) {
                throw new Error(
                    result?.message || "Delete failed"
                );
            }

            toast.success(
                "Mapping deleted successfully"
            );

            setDeleteOpen(false);

            fetchMappings();
        } catch (error) {
            toast.error(error.message);
        } finally {
            setActionLoading(false);
        }
    };

    const getMappingDetails = async (id) => {
        try {
            const token = localStorage.getItem(
                "astroVani-admin-token"
            );

            const response = await fetch(
                `${process.env.REACT_APP_BASEURL}/admin/pooja/mapping/${id}`,
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            const result = await response.json();

            return result?.data;
        } catch (error) {
            console.log(error);
        }
    };

    const handleExport = async () => {
        try {
            setExportLoading(true);

            const token = localStorage.getItem(
                "astroVani-admin-token"
            );

            const response = await fetch(
                `${process.env.REACT_APP_BASEURL}/admin/pooja/mapping`,
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            const result = await response.json();

            const exportData = result?.data || [];

            if (!exportData.length) {
                toast.error("No data found");
                return;
            }

            const rows = exportData.map((item) => ({
                "Pooja Name":
                    item?.poojaId?.name || "",

                Astrologer:
                    item?.astrologerId?.fullName || "",

                "Base Price":
                    item?.poojaId?.basePrice || 0,

                "Final User Price":
                    item?.finalUserPrice || 0,

                "Final Offer User Price":
                    item?.finalOfferUserPrice || 0,

                "Company Share %":
                    item?.companyShare || 60,

                "Astrologer Share %":
                    item?.astrologerShare || 40,

                // "Pooja Description":
                //     item?.poojaDescription || "",

                // "Short Description":
                //     item?.shortDescription || "",

                "Duration (mins)":
                    item?.poojaId?.duration || 0,

                // "Assigned By":
                //     item?.assignedBy || "",

                Status: item?.isActive
                    ? "Active"
                    : "Inactive",

                CreatedAt: item?.createdAt
                    ? new Date(
                        item.createdAt
                    ).toLocaleString()
                    : "",

                // UpdatedAt: item?.updatedAt
                //     ? new Date(
                //         item.updatedAt
                //     ).toLocaleString()
                //     : "",
            }));

            const worksheet =
                XLSX.utils.json_to_sheet(rows);

            const workbook =
                XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Pooja Mapping"
            );

            XLSX.writeFile(
                workbook,
                "Pooja_Mapping.xlsx"
            );

            toast.success(
                "Export completed successfully"
            );
        } catch (error) {
            console.log(error);
            toast.error("Export failed");
        } finally {
            setExportLoading(false);
        }
    };

    const rows = mappings.map((item, index) => ({
        id: item._id,

        sno:
            paginationModel.page *
            paginationModel.pageSize +
            index +
            1,

        poojaName: item.poojaId?.name || "-",

        astrologerName:
            item.astrologerId?.fullName || "-",

        basePrice:
            item.poojaId?.basePrice || 0,

        finalUserPrice:
            item.finalUserPrice || 0,

        finalOfferUserPrice:
            item.finalOfferUserPrice || 0,

        duration:
            item.poojaId?.duration || 0,

        poojaDescription:
            item.poojaDescription || "-",

        shortDescription:
            item.shortDescription || "-",

        assignedBy:
            item.assignedBy || "-",

        companyShare:
            item.companyShare || 60,

        astrologerShare:
            item.astrologerShare || 40,

        isActive:
            item.isActive,

        createdAt:
            item.createdAt,

        updatedAt:
            item.updatedAt,

        originalData: item,
    }));

    const columns = [
        {
            field: "sno",
            headerName: "S.No",
            width: 80,
            align: "center",
            headerAlign: "center",
        }, {
            field: "actions",
            headerName: "Actions",
            width: 150,
            sortable: false,
            filterable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (
                <>
                    <Tooltip title="View">
                        <IconButton
                            color="primary"
                            onClick={() =>
                                handleView(params.row.originalData)
                            }
                        >
                            <i className="icofont-eye"></i>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Edit">
                        <IconButton
                            color="success"
                            onClick={() =>
                                handleEdit(params.row.originalData)
                            }
                        >
                            <i className="icofont-edit"></i>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Delete">
                        <IconButton
                            color="error"
                            onClick={() =>
                                handleDeleteOpen(params.row.originalData)
                            }
                        >
                            <i className="icofont-ui-delete"></i>
                        </IconButton>
                    </Tooltip>
                </>
            ),
        },
        {
            field: "poojaName",
            headerName: "Pooja",
            flex: 1,
            minWidth: 180,
        },
        {
            field: "astrologerName",
            headerName: "Astrologer",
            flex: 1,
            minWidth: 180,
        },
        {
            field: "basePrice",
            headerName: "Base Price",
            width: 130,
            renderCell: (params) => (
                <Chip
                    label={`₹${params.value}`}
                    color="primary"
                    size="small"
                />
            ),
        },
        {
            field: "finalUserPrice",
            headerName: "Final Price",
            width: 140,
            renderCell: (params) => (
                <Chip
                    label={`₹${params.value}`}
                    color="success"
                    size="small"
                />
            ),
        },
        {
            field: "finalOfferUserPrice",
            headerName: "Offer Price",
            width: 140,
            renderCell: (params) => (
                <Chip
                    label={`₹${params.value}`}
                    color="success"
                    size="small"
                />
            ),
        },
        {
            field: "duration",
            headerName: "Duration",
            width: 120,
            renderCell: (params) => (
                <Chip
                    label={`${params.value} mins`}
                    color="primary"
                    size="small"
                />
            ),
        },
        // {
        //     field: "poojaDescription",
        //     headerName: "Description",
        //     width: 180,
        // },
        // {
        //     field: "shortDescription",
        //     headerName: "Short Desc",
        //     width: 180,
        // },
        // {
        //     field: "assignedBy",
        //     headerName: "Assigned By",
        //     width: 150,
        // },
        {
            field: "companyShare",
            headerName: "Company %",
            width: 120,
            renderCell: (params) => (
                <Chip
                    label={`${params.value}%`}
                    color="warning"
                    size="small"
                />
            ),
        },
        {
            field: "astrologerShare",
            headerName: "Astrologer %",
            width: 130,
            renderCell: (params) => (
                <Chip
                    label={`${params.value}%`}
                    color="secondary"
                    size="small"
                />
            ),
        },
        {
            field: "isActive",
            headerName: "Status",
            width: 120,
            renderCell: (params) => (
                <Chip
                    label={params.value ? "Active" : "Inactive"}
                    color={params.value ? "success" : "error"}
                    size="small"
                />
            ),
        },
        {
            field: "createdAt",
            headerName: "Created At",
            width: 180,
            valueFormatter: (params) =>
                params
                    ? new Date(params).toLocaleString()
                    : "-",
        },
        // {
        //     field: "updatedAt",
        //     headerName: "Updated At",
        //     width: 180,
        //     valueFormatter: (params) =>
        //         params
        //             ? new Date(params).toLocaleString()
        //             : "-",
        // },
    ];

    const handleView = async (row) => {
        // Show immediately using list data (has all fields including companyShare/astrologerShare)
        setSelectedMapping(row);
        setViewOpen(true);
        // Fetch detail for extra fields like image, then merge
        const data = await getMappingDetails(row._id);
        if (data) {
            setSelectedMapping((prev) => ({ ...prev, ...data }));
        }
    };

    return (
        <div className="container-fluid">

            <Card>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        flexWrap="wrap"
                        gap={2}
                        mb={2}
                    >
                        <Typography
                            variant="h6"
                            fontWeight={600}
                        >
                            Pooja Mapping List
                        </Typography>

                        <Box
                            display="flex"
                            gap={1}
                            flexWrap="wrap"
                        >
                            <Select
                                size="small"
                                value={searchBy}
                                onChange={(e) => setSearchBy(e.target.value)}
                                sx={{ minWidth: 150 }}
                            >
                                {SEARCH_BY_OPTIONS.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>

                            <TextField
                                size="small"
                                placeholder={`Search by ${SEARCH_BY_OPTIONS.find(o => o.value === searchBy)?.label || "..."}`}
                                value={searchText}
                                onChange={(e) =>
                                    setSearchText(
                                        e.target.value
                                    )
                                }
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleApplySearch();
                                    }
                                }}
                            />

                            <Button
                                variant="contained"
                                onClick={handleApplySearch}
                            >
                                Search
                            </Button>

                            <Button
                                variant="outlined"
                                onClick={handleResetSearch}
                            >
                                Reset
                            </Button>

                            <Button
                                variant="contained"
                                color="success"
                                startIcon={
                                    exportLoading ? (
                                        <CircularProgress
                                            size={16}
                                            color="inherit"
                                        />
                                    ) : (
                                        <BsDownload />
                                    )
                                }
                                onClick={handleExport}
                                disabled={exportLoading}
                            >
                                {exportLoading
                                    ? "Exporting..."
                                    : "Export"}
                            </Button>
                        </Box>
                    </Box>
                    <Box sx={{ width: "100%" }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            autoHeight
                            disableRowSelectionOnClick
                            hideFooterPagination
                        />
                    </Box>

                    <TablePagination
                        component="div"
                        count={pagination?.totalDocs || 0}
                        page={paginationModel.page}
                        rowsPerPage={paginationModel.pageSize}
                        onPageChange={(e, newPage) =>
                            setPaginationModel((prev) => ({
                                ...prev,
                                page: newPage,
                            }))
                        }
                        onRowsPerPageChange={(e) =>
                            setPaginationModel({
                                page: 0,
                                pageSize: parseInt(
                                    e.target.value,
                                    10
                                ),
                            })
                        }
                        rowsPerPageOptions={[10, 25, 50]}
                    />
                </CardContent>
            </Card>
            <Dialog
                open={viewOpen}
                onClose={() => setViewOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ pb: 1, fontSize: '1rem', fontWeight: 600 }}>
                    Pooja Mapping Details
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ pt: 2 }}>
                    {selectedMapping && (
                        <Grid container spacing={1.5}>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Pooja Name</Typography>
                                <Typography variant="body2">{selectedMapping?.poojaId?.name || '-'}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Astrologer</Typography>
                                <Typography variant="body2">{selectedMapping?.astrologerId?.fullName || '-'}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Status</Typography>
                                <Chip
                                    label={selectedMapping?.isActive ? "Active" : "Inactive"}
                                    color={selectedMapping?.isActive ? "success" : "error"}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Base Price</Typography>
                                <Typography variant="body2">₹{selectedMapping?.poojaId?.basePrice ?? '-'}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Price</Typography>
                                <Typography variant="body2">₹{selectedMapping?.finalUserPrice ?? '-'}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Offer Price</Typography>
                                <Typography variant="body2">₹{selectedMapping?.finalOfferUserPrice ?? '-'}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Company Share</Typography>
                                <Typography variant="body2">{selectedMapping?.companyShare ?? '-'}%</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Astrologer Share</Typography>
                                <Typography variant="body2">{selectedMapping?.astrologerShare ?? '-'}%</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Created At</Typography>
                                <Typography variant="body2">
                                    {selectedMapping?.createdAt ? new Date(selectedMapping.createdAt).toLocaleString() : '-'}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Updated At</Typography>
                                <Typography variant="body2">
                                    {selectedMapping?.updatedAt ? new Date(selectedMapping.updatedAt).toLocaleString() : '-'}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Duration</Typography>
                                <Typography variant="body2">{selectedMapping?.poojaId?.duration ? `${selectedMapping.poojaId.duration} mins` : '-'}</Typography>
                            </Grid>
                            {/* <Grid item xs={4}>
                                <Typography variant="caption" color="text.secondary" display="block">Assigned By</Typography>
                                <Typography variant="body2">{selectedMapping?.assignedBy || '-'}</Typography>
                            </Grid> */}
                            {selectedMapping?.shortDescription && (
                                <Grid item xs={12}>
                                    <Typography variant="caption" color="text.secondary" display="block">Short Description</Typography>
                                    <Typography variant="body2">{selectedMapping.shortDescription}</Typography>
                                </Grid>
                            )}
                            {selectedMapping?.poojaDescription && (
                                <Grid item xs={12}>
                                    <Typography variant="caption" color="text.secondary" display="block">Pooja Description</Typography>
                                    <Typography variant="body2" style={{ whiteSpace: 'pre-wrap', fontSize: '14px', color: '#000000' }}>{selectedMapping.poojaDescription}</Typography>
                                </Grid>
                            )}
                            {selectedMapping?.poojaId?.image && (
                                <Grid item xs={12}>
                                    <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>Pooja Image</Typography>
                                    <img
                                        src={selectedMapping.poojaId.image}
                                        alt="Pooja"
                                        style={{ width: 140, borderRadius: 6 }}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" size="small" onClick={() => setViewOpen(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={editOpen}
                onClose={() => setEditOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ pb: 1 }}>
                    <Typography sx={{ fontSize: '1rem', fontWeight: 600 }}>Update Mapping</Typography>
                    {selectedMapping && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.6 }}>
                            <strong>Pooja:</strong> {selectedMapping?.poojaId?.name || '-'} | <strong>Duration:</strong> {selectedMapping?.poojaId?.duration || '-'} mins | <strong>Base Price:</strong> ₹{selectedMapping?.poojaId?.basePrice || '-'}
                            <br />
                            <strong>Astro:</strong> {selectedMapping?.astrologerId?.fullName || '-'} | <strong>Per Min Video Cost:</strong> ₹{selectedMapping?.astrologerId?.videoCall?.offerPricePerMinute || '-'}
                        </Typography>
                    )}
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ pt: 2.5 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Price"
                                type="number"
                                value={editData.finalUserPrice}
                                inputProps={{ min: 0 }}
                                onKeyDown={(e) => { if (e.key === '-') e.preventDefault(); }}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === '' || Number(val) >= 0)
                                        setEditData({ ...editData, finalUserPrice: val });
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Offer Price"
                                type="number"
                                value={editData.finalOfferUserPrice}
                                inputProps={{ min: 0 }}
                                onKeyDown={(e) => { if (e.key === '-') e.preventDefault(); }}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === '' || Number(val) >= 0)
                                        setEditData({ ...editData, finalOfferUserPrice: val });
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Company Share %"
                                type="number"
                                value={editData.companyShare}
                                inputProps={{ min: 0, max: 100 }}
                                onKeyDown={(e) => { if (e.key === '-') e.preventDefault(); }}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === '' || (Number(val) >= 0 && Number(val) <= 100)) {
                                        setEditData({ ...editData, companyShare: val, astrologerShare: val === '' ? '' : String(100 - Number(val)) });
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Astrologer Share %"
                                type="number"
                                disabled
                                value={editData.astrologerShare}
                                inputProps={{ min: 0, max: 100 }}
                                onKeyDown={(e) => { if (e.key === '-') e.preventDefault(); }}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === '' || (Number(val) >= 0 && Number(val) <= 100)) {
                                        setEditData({ ...editData, astrologerShare: val, companyShare: val === '' ? '' : String(100 - Number(val)) });
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Pooja Description (Optional)"
                                multiline
                                rows={2}
                                value={editData.poojaDescription}
                                onChange={(e) =>
                                    setEditData({
                                        ...editData,
                                        poojaDescription: e.target.value,
                                    })
                                }
                            />
                        </Grid>
                    </Grid>

                    {/* Live price calculation */}
                    {(editData.finalUserPrice || editData.finalOfferUserPrice || editData.companyShare || editData.astrologerShare) && (
                        <Box sx={{ bgcolor: '#f0f9f0', border: '1px solid #c8e6c9', borderRadius: '8px', p: 1.5, mt: 1 }}>
                            <Typography variant="caption" color="#2e7d32" fontWeight={700} display="block" mb={1}>PRICE CALCULATION</Typography>
                            <Box display="flex" gap={2} flexWrap="wrap">
                                {editData.finalUserPrice && (
                                    <Box textAlign="center">
                                        <Typography variant="caption" color="text.secondary" display="block">Price</Typography>
                                        <Typography variant="body2" fontWeight={700}>₹{editData.finalUserPrice}</Typography>
                                    </Box>
                                )}
                                {editData.finalOfferUserPrice && (
                                    <Box textAlign="center">
                                        <Typography variant="caption" color="text.secondary" display="block">Offer Price</Typography>
                                        <Typography variant="body2" fontWeight={700} color="#388e3c">₹{editData.finalOfferUserPrice}</Typography>
                                    </Box>
                                )}
                                {editData.finalOfferUserPrice && editData.companyShare && (
                                    <Box textAlign="center">
                                        <Typography variant="caption" color="text.secondary" display="block">Company ({editData.companyShare}%)</Typography>
                                        <Typography variant="body2" fontWeight={700} color="#1976d2">
                                            ₹{((Number(editData.finalOfferUserPrice) * Number(editData.companyShare)) / 100).toFixed(2)}
                                        </Typography>
                                    </Box>
                                )}
                                {editData.finalOfferUserPrice && editData.astrologerShare && (
                                    <Box textAlign="center">
                                        <Typography variant="caption" color="text.secondary" display="block">Astrologer ({editData.astrologerShare}%)</Typography>
                                        <Typography variant="body2" fontWeight={700} color="#7b1fa2">
                                            ₹{((Number(editData.finalOfferUserPrice) * Number(editData.astrologerShare)) / 100).toFixed(2)}
                                        </Typography>
                                    </Box>
                                )}
                                {editData.companyShare && editData.astrologerShare && (
                                    <Box textAlign="center">
                                        <Typography variant="caption" color={Number(editData.companyShare) + Number(editData.astrologerShare) === 100 ? 'success.main' : 'error.main'} fontWeight={700} display="block">
                                            Share Total
                                        </Typography>
                                        <Typography variant="body2" fontWeight={700} color={Number(editData.companyShare) + Number(editData.astrologerShare) === 100 ? '#2e7d32' : '#d32f2f'}>
                                            {Number(editData.companyShare) + Number(editData.astrologerShare)}% {Number(editData.companyShare) + Number(editData.astrologerShare) === 100 ? '✓' : '≠ 100'}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() =>
                            setEditOpen(false)
                        }
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleUpdate}
                        disabled={actionLoading}
                    >
                        {actionLoading
                            ? "Updating..."
                            : "Update"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={deleteOpen}
                onClose={() => setDeleteOpen(false)}
            >
                <DialogTitle>
                    Delete Mapping
                </DialogTitle>

                <DialogContent>
                    Are you sure you want to delete
                    this mapping?
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() =>
                            setDeleteOpen(false)
                        }
                    >
                        Cancel
                    </Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={handleDelete}
                        disabled={actionLoading}
                    >
                        {actionLoading
                            ? "Deleting..."
                            : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default PoojaMapping;